import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from '@heroicons/react/24/solid';

const testimonials = [
  {
    quote:
      "TrueLog has been instrumental in streamlining our global shipping operations. Their sea freight services are top-notch, ensuring our goods arrive on time and in perfect condition. The team's expertise in handling complex shipments has been invaluable to our business.",
    author: 'James L',
    role: 'Operations Manager',
  },
  {
    quote:
      'I was very impressed with the whole process and all of the staff that were involved behind the scenes in making all the deliveries run so smoothly.',
    author: 'Melissa J. T',
    role: '',
  },
];

const Testimonials: React.FC = () => {
  return (
    <section className="relative overflow-hidden py-14 lg:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-12 top-24 h-64 w-64 rounded-full bg-[#385CF2]/8 blur-[120px]" />
        <div className="absolute right-12 bottom-12 h-80 w-80 rounded-full bg-[#0E9ED5]/10 blur-[140px]" />
      </div>

      <div className="container-custom relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.75 }}
          className="mx-auto mb-10 max-w-3xl text-center"
        >
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">What they say</p>
          <h2 className="mt-4 text-slate-950">Execution that scales globally</h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2">
          {testimonials.map((testimonial, index) => (
            <motion.article
              key={testimonial.author}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.1 }}
              className="surface-card flex h-full flex-col p-7 sm:p-8"
            >
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, starIndex) => (
                  <StarIcon key={starIndex} className="h-4 w-4 text-amber-400" />
                ))}
              </div>

              <blockquote className="mt-6 text-base leading-8 text-slate-700 sm:text-lg">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>

              <div className="mt-6 border-t border-slate-200 pt-5">
                <p className="text-base font-semibold text-slate-950">{testimonial.author}</p>
                {testimonial.role && <p className="mt-1 text-sm text-slate-500">{testimonial.role}</p>}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
